import { gql } from "@apollo/client";

export const DELETE_INDICACION = gql`
  mutation deleteIndicacion($idIndicacion: Int!) {
    deleteIndicacion(idIndicacion: $idIndicacion) {
      success
      error
      valorEsperado
    }
  }
`;